<div
  class="login-view"
  [style.background]="'url(/assets/images/' + background + ')'"
  [style.background-size]="'cover'"
>
  <div class="login-banner">
    <img src="/assets/images/line-sim-icon-144.png" height="48" style="display: inline-block; margin-top: -16px; margin-right: 24px;"/>
    <h2 style="display: inline-block; margin-top: 12px;">Project Manager</h2>
  </div>
  <div
    class="login-form"
  >

    <h2>Login</h2>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <label for="username">Username</label>
        <input
          type="text"
          formControlName="username"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
        />
        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
          <div *ngIf="f.username.errors.required">Username is required</div>
        </div>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          formControlName="password"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
        />
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
          <div *ngIf="f.password.errors.required">Password is required</div>
        </div>
      </div>

      <div class="form-group">

        <button [disabled]="loading" class="btn btn-danger">Login</button>

        <div  *ngIf="loading" class="fa-lg" style="display: inline-block; margin-left: 8px;">
          <i class="fas fa-circle-notch fa-spin"></i>
        </div>

        <!-- public GKE cloud deployed, no rando user registration
        <a routerLink="/register" class="btn btn-link ">Register</a>
        -->

      </div>

      <p>OR</p>

      <!--
      <div class="form-group">
        <a href="{{microsoft_sso}}"><img src="assets/images/cn-login-button.png"></a>
      </div>
      -->

      <div class="form-group">
        <a href="{{google_sso}}"><img src="assets/images/google_signin_normal.png"></a>
      </div>

    </form>

  </div>

</div>
